import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/modules/gpt/icons';

export const VendingEventIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <g clip-path="url(#clip0_3027_559)">
      <path
        d="M21.43 3.93V20.07C21.43 21.69 20.1 23 18.45 23H5.55001C3.91001 23 2.57001 21.69 2.57001 20.07V3.93C2.57001 2.44 3.71001 1.2 5.17001 1.02C5.29001 1.01 5.41001 1 5.54001 1H18.45C18.84 1 19.21 1.07 19.55 1.21C20.65 1.64 21.43 2.7 21.43 3.94V3.93Z"
        fill="#F8203D"
      />
      <path
        opacity="0.3"
        d="M7.91999 22.87H5.64999C4.00999 22.87 2.67999 21.56 2.67999 19.94V3.8C2.67999 2.31 3.99999 0.65 7.75999 1.17C2.45999 3.35 4.20999 14.82 5.64999 18.67C6.20999 20.16 6.96999 21.59 7.91999 22.87Z"
        fill="white"
      />
      <path
        d="M15.77 19.43C15.77 19.93 15.56 20.38 15.23 20.71C14.9 21.04 14.44 21.24 13.93 21.24H6.18001C5.17001 21.24 4.35001 20.43 4.35001 19.43C4.35001 18.93 4.56001 18.48 4.89001 18.15C5.22001 17.82 5.68001 17.62 6.19001 17.62H13.94C14.51 17.62 15.02 17.88 15.36 18.28C15.62 18.59 15.77 18.99 15.77 19.42V19.43Z"
        fill="#315E61"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M19.52 14.22H17.08V16.18H19.52V14.22Z"
        fill="#315E61"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M18.3 10.93C17.51 10.93 16.87 10.3 16.87 9.52V4.27C16.87 3.49 17.51 2.86 18.3 2.86C19.09 2.86 19.73 3.49 19.73 4.27V9.52C19.73 10.3 19.09 10.93 18.3 10.93Z"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M18.15 5.33C18.15 5.56 17.96 5.75 17.72 5.75C17.57 5.75 17.44 5.68 17.37 5.56C17.33 5.49 17.3 5.41 17.3 5.33C17.3 5.1 17.49 4.91 17.73 4.91C17.87 4.91 17.99 4.97 18.07 5.07C18.13 5.14 18.16 5.23 18.16 5.32L18.15 5.33Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M19.31 5.33C19.31 5.56 19.12 5.75 18.88 5.75C18.73 5.75 18.6 5.68 18.53 5.56C18.49 5.49 18.46 5.41 18.46 5.33C18.46 5.1 18.65 4.91 18.89 4.91C19.03 4.91 19.15 4.97 19.23 5.07C19.29 5.14 19.32 5.23 19.32 5.32L19.31 5.33Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M18.14 6.48C18.14 6.71 17.95 6.9 17.71 6.9C17.56 6.9 17.43 6.83 17.36 6.71C17.32 6.64 17.29 6.56 17.29 6.48C17.29 6.25 17.48 6.06 17.72 6.06C17.86 6.06 17.98 6.12 18.06 6.22C18.12 6.29 18.15 6.38 18.15 6.47L18.14 6.48Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M19.31 6.48C19.31 6.71 19.12 6.9 18.88 6.9C18.73 6.9 18.6 6.83 18.53 6.71C18.49 6.64 18.46 6.56 18.46 6.48C18.46 6.25 18.65 6.06 18.89 6.06C19.03 6.06 19.15 6.12 19.23 6.22C19.29 6.29 19.32 6.38 19.32 6.47L19.31 6.48Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M18.14 7.63C18.14 7.86 17.95 8.05 17.71 8.05C17.56 8.05 17.43 7.98 17.36 7.86C17.32 7.79 17.29 7.71 17.29 7.63C17.29 7.4 17.48 7.21 17.72 7.21C17.86 7.21 17.98 7.27 18.06 7.37C18.12 7.44 18.15 7.53 18.15 7.62L18.14 7.63Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M19.31 7.63C19.31 7.86 19.12 8.05 18.88 8.05C18.73 8.05 18.6 7.98 18.53 7.86C18.49 7.79 18.46 7.71 18.46 7.63C18.46 7.4 18.65 7.21 18.89 7.21C19.03 7.21 19.15 7.27 19.23 7.37C19.29 7.44 19.32 7.53 19.32 7.62L19.31 7.63Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M18.14 8.84C18.14 9.07 17.95 9.26 17.71 9.26C17.56 9.26 17.43 9.19 17.36 9.07C17.32 9 17.29 8.92 17.29 8.84C17.29 8.61 17.48 8.42 17.72 8.42C17.86 8.42 17.98 8.48 18.06 8.58C18.12 8.65 18.15 8.74 18.15 8.83L18.14 8.84Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M19.31 8.84C19.31 9.07 19.12 9.26 18.88 9.26C18.73 9.26 18.6 9.19 18.53 9.07C18.49 9 18.46 8.92 18.46 8.84C18.46 8.61 18.65 8.42 18.89 8.42C19.03 8.42 19.15 8.48 19.23 8.58C19.29 8.65 19.32 8.74 19.32 8.83L19.31 8.84Z"
        fill="#D9DFDF"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M19.31 12.6C19.31 12.87 19.2 13.12 19.02 13.3C18.84 13.48 18.59 13.59 18.31 13.59C18.16 13.59 18.02 13.56 17.9 13.5C17.74 13.43 17.61 13.32 17.51 13.19C17.38 13.02 17.31 12.82 17.31 12.59C17.31 12.32 17.42 12.07 17.6 11.89C17.78 11.71 18.03 11.6 18.31 11.6C18.49 11.6 18.67 11.65 18.82 11.73C18.9 11.77 18.97 11.83 19.03 11.89C19.21 12.06 19.32 12.3 19.32 12.56C19.32 12.56 19.32 12.58 19.32 12.59L19.31 12.6Z"
        fill="#315E61"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        d="M15.77 4.63V14.4C15.77 15.38 14.96 16.17 13.97 16.17H6.15001C5.74001 16.17 5.37001 16.04 5.07001 15.81C4.63001 15.49 4.35001 14.97 4.35001 14.39V4.63C4.35001 3.65 5.16001 2.86 6.15001 2.86H13.97C14.2 2.86 14.43 2.9 14.63 2.98C15.3 3.24 15.77 3.88 15.77 4.63Z"
        fill="#315E61"
        stroke="white"
        stroke-width="0.46"
        stroke-miterlimit="10"
      />
      <path
        opacity="0.2"
        d="M21.32 8.84V20C21.32 21.62 19.99 22.93 18.34 22.93H13.61C16.18 21.43 20.38 20.96 21.32 8.84Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.06 6.27C15.06 6.27 13.74 6.25 12.86 7.98C13.04 8.18 13.17 8.5 13.18 8.85C13.19 9.46 12.86 9.95 12.44 9.94C12.02 9.93 11.66 9.44 11.65 8.83C11.65 8.43 11.79 8.07 12.01 7.88C11.65 7.16 11.04 6.24 10.05 5.5C9.07999 6.22 8.51999 7.14 8.18999 7.86C8.40999 8.06 8.56999 8.41 8.57999 8.8C8.58999 9.41 8.25999 9.9 7.83999 9.89C7.41999 9.88 7.05999 9.39 7.04999 8.78C7.04999 8.42 7.15999 8.1 7.33999 7.9C6.38999 6.16 5.06999 6.16 5.06999 6.16C6.62999 9.18 6.31999 12.7 6.31999 12.7L10.22 12.74L14.12 12.78C14.12 12.78 13.65 9.25 15.07 6.26L15.06 6.27Z"
        fill="url(#paint0_linear_3027_559)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.89 9.9C7.89 9.9 7.85 9.9 7.83 9.9C7.41 9.9 7.05 9.4 7.04 8.79C7.04 8.43 7.15 8.11 7.33 7.91C6.56 6.5 5.52 6.2 5.06 6.17H5.18C5.18 6.17 6.5 6.17 7.45 7.91C7.27 8.11 7.15 8.43 7.16 8.79C7.17 9.37 7.49 9.85 7.89 9.89V9.9Z"
        fill="url(#paint1_linear_3027_559)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.39 9.95C12.39 9.95 12.43 9.95 12.45 9.95C12.87 9.95 13.2 9.46 13.19 8.86C13.19 8.5 13.05 8.18 12.86 7.98C13.57 6.58 14.6 6.3 15.05 6.28H14.93C14.93 6.28 13.61 6.26 12.74 7.98C12.93 8.18 13.06 8.5 13.07 8.86C13.08 9.44 12.78 9.91 12.39 9.95Z"
        fill="url(#paint2_linear_3027_559)"
      />
      <g filter="url(#filter0_d_3027_559)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.24 12.65C14.24 12.3 12.42 12 10.18 11.98C7.94001 11.96 6.14 12.22 6.15 12.57V12.86H6.59C7.26 13.07 8.63 13.22 10.21 13.24C11.79 13.26 13.15 13.13 13.81 12.93H14.25V12.65H14.24Z"
          fill="url(#paint3_linear_3027_559)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.25 12.93C14.25 13.28 12.45 13.54 10.22 13.52C7.99 13.5 6.17 13.2 6.16 12.85C6.15 12.5 7.96 12.24 10.19 12.26C12.42 12.28 14.24 12.58 14.25 12.93Z"
        fill="url(#paint4_linear_3027_559)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1 12.95C14.1 13.21 12.37 13.4 10.21 13.38C8.05 13.36 6.31 13.13 6.3 12.87C6.29 12.61 8.03 12.42 10.19 12.44C12.34 12.46 14.09 12.69 14.1 12.95Z"
        fill="url(#paint5_linear_3027_559)"
        style={{ mixBlendMode: 'multiply' }}
      />
      <g filter="url(#filter1_d_3027_559)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.23 11.51C6.23 11.16 7.98 10.9 10.16 10.93C12.33 10.96 14.1 11.26 14.12 11.61V11.33C14.1 10.98 12.33 10.68 10.15 10.65C7.97 10.62 6.21 10.88 6.22 11.23V11.52L6.23 11.51Z"
          fill="url(#paint6_linear_3027_559)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.16 10.93C7.97999 10.9 6.21999 11.16 6.22999 11.51C6.22999 11.55 6.25999 11.6 6.30999 11.64C6.33999 11.52 6.41999 11.41 6.56999 11.39C7.06999 11.21 8.46999 11.09 10.15 11.12C11.88 11.14 13.33 11.31 13.79 11.51C13.81 11.51 13.83 11.52 13.85 11.54C13.86 11.54 13.88 11.56 13.89 11.56C13.95 11.61 14 11.67 14.03 11.75C14.08 11.71 14.11 11.67 14.11 11.62C14.11 11.27 12.33 10.97 10.15 10.94L10.16 10.93Z"
        fill="url(#paint7_linear_3027_559)"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        opacity="0.8"
        d="M10.29 5.97C9.32001 5.7 10.5 7.41 11.02 7.39C11.53 7.37 11.1 6.2 10.29 5.97Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3027_559"
        x="-8.85004"
        y="1.97892"
        width="28.1"
        height="21.2631"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3027_559" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3027_559"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3027_559"
        x="-8.78004"
        y="0.647644"
        width="27.9"
        height="20.9624"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3027_559" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3027_559"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3027_559"
        x1="5.07447"
        y1="9.24614"
        x2="15.0742"
        y2="9.17284"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FADA40" />
        <stop offset="0.03" stop-color="#F1C734" />
        <stop offset="0.12" stop-color="#DD9A18" />
        <stop offset="0.19" stop-color="#D07E06" />
        <stop offset="0.23" stop-color="#CC7400" />
        <stop offset="0.29" stop-color="#DC7C00" />
        <stop offset="0.34" stop-color="#EC8500" />
        <stop offset="0.39" stop-color="#EE950C" />
        <stop offset="0.47" stop-color="#F5C12D" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.71" stop-color="#FFFBE2" />
        <stop offset="0.73" stop-color="#FDF3C5" />
        <stop offset="0.78" stop-color="#FBE699" />
        <stop offset="0.82" stop-color="#F9DC74" />
        <stop offset="0.87" stop-color="#F8D558" />
        <stop offset="0.91" stop-color="#F7CF44" />
        <stop offset="0.96" stop-color="#F7CC38" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3027_559"
        x1="5.78019"
        y1="5.92988"
        x2="7.83617"
        y2="10.1291"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FCE3A1" />
        <stop offset="0.07" stop-color="#FCDF8B" />
        <stop offset="0.18" stop-color="#FCD96F" />
        <stop offset="0.25" stop-color="#FDD865" />
        <stop offset="0.48" stop-color="#FDE19B" />
        <stop offset="0.83" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3027_559"
        x1="14.3361"
        y1="6.02471"
        x2="12.3884"
        y2="10.1351"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.24" stop-color="#FCE3A1" />
        <stop offset="0.28" stop-color="#FCDF8B" />
        <stop offset="0.34" stop-color="#FCD96F" />
        <stop offset="0.38" stop-color="#FDD865" />
        <stop offset="0.55" stop-color="#FFEBA8" />
        <stop offset="0.72" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3027_559"
        x1="7.04282"
        y1="7.64767"
        x2="16.4626"
        y2="7.57861"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3027_559"
        x1="6.16187"
        y1="12.9783"
        x2="14.2516"
        y2="12.919"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3027_559"
        x1="6.30203"
        y1="12.9992"
        x2="14.1018"
        y2="12.9421"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3027_559"
        x1="7.18531"
        y1="6.68398"
        x2="16.2035"
        y2="5.39407"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3027_559"
        x1="6.30376"
        y1="12.0327"
        x2="14.0153"
        y2="10.9297"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <clipPath id="clip0_3027_559">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
